import { jwtDecode } from 'jwt-decode';
import { clearPromptSetupState } from './userProfile';

export const AUTH_EXPIRED_MESSAGE =
  'Your session has expired. Please sign in again to continue onboarding.';

export const AUTH_SESSION_STORAGE_KEYS = [
  'accessToken',
  'refreshToken',
  'userType',
  'user',
  'createPromptStep',
] as const;

export function clearAuthStorage(): void {
  AUTH_SESSION_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
  sessionStorage.removeItem('latestPromptProgress');
  localStorage.removeItem('skipscreen_role_specific_prompts');
  clearPromptSetupState();
}

export function getAccessToken(): string | null {
  return localStorage.getItem('accessToken');
}

export function getRefreshToken(): string | null {
  return localStorage.getItem('refreshToken');
}

export function decodeTokenExpiryMs(token: string): number {
  try {
    return jwtDecode<{ exp: number }>(token).exp * 1000;
  } catch {
    return 0;
  }
}

export function isAccessTokenExpired(token?: string | null): boolean {
  const value = token ?? getAccessToken();
  if (!value) return true;
  const exp = decodeTokenExpiryMs(value);
  if (!exp) return false;
  return Date.now() >= exp;
}
